export function useDate() {
  const { locale } = useI18n()
  const dateFormatter = new Intl.DateTimeFormat(locale.value, {
    dateStyle: 'long',
  })

  return {
    formatDate(date: string | Date) {
      return dateFormatter.format(new Date(date))
    },
  }
}
